// Port of api/fuel/app/classes/insights/players/hindex.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'hindex',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['hindex'],
	run: function(type, owner, userIndex, detail) {
		var data = {
			hindex: [],
			total: 0
		}
		var players = (this._data.players || []).slice().sort(function(a, b) {
			if (b.hindex !== a.hindex) return b.hindex - a.hindex
			if (b.totalPlays !== a.totalPlays) return b.totalPlays - a.totalPlays
			var byName = String(a.primaryName || '').localeCompare(String(b.primaryName || ''))
			if (byName !== 0) return byName
			return (parseInt(a.id, 10) || 0) - (parseInt(b.id, 10) || 0)
		})
		var limit = detail ? 250 : 5
		data.total = players.length
		if (players.length > limit) players = players.slice(0, limit)

		for (var i = 0; i < players.length; i++) {
			data.hindex.push({
				id: parseInt(players[i].id, 10) || 0,
				slug: players[i].slug,
				name: players[i].primaryName,
				username: players[i].username,
				count: players[i].hindex,
				plays: players[i].totalPlays
			})
		}

		return {
			hindex: data
		}
	}
})
